// extracted by mini-css-extract-plugin
export default {"container":"container____EAS_","buttonBox":"buttonBox___GcQaZ","form":"form___JtaT4","label":"label___daDza","value":"value___HFqh9","upload":"upload___HKWs_"};